import { combineReducers } from 'redux';
import * as R from 'ramda';

import { isType } from '../../utils/ActionUtils';
import { SET_VIDEO_SOURCE } from '../../actions/ActionTypes';

/*
 * Basic Reducer logic:
 * --------------------
 * If: the type of action coming through is {type}, do something with it, get the value or reduce the data and return the new value
 * Else: return the state
*/

const durationReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pipe(R.pathOr(state, [ 'payload', 'duration' ]), (duration) => parseFloat(duration)) ], // parse as float and return
    [ R.T, R.always(state) ]
])(action);


const collectionTitleReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'collectionTitle' ]) ],
    [ R.T, R.always(state) ]
])(action);


const titleReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'title' ]) ],
    [ R.T, R.always(state) ]
])(action);


const titleIdReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'titleId' ]) ],
    [ R.T, R.always(state) ]
])(action);


const typeReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'type' ]) ],
    [ R.T, R.always(state) ]
])(action);


const idReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'id' ]) ],
    [ R.T, R.always(state) ]
])(action);


const contentURLReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'contentURL' ]) ],
    [ R.T, R.always(state) ]
])(action);


const vttURLReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'vttURL' ]) ],
    [ R.T, R.always(state) ]
])(action);


const posterReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'poster' ]) ],
    [ R.T, R.always(state) ]
])(action);

const mimeTypeReducer = (state = null, action) => R.cond([
    [ isType(SET_VIDEO_SOURCE), R.pathOr(state, [ 'payload', 'mimeType' ]) ],
    [ R.T, R.always(state) ]
])(action);


export default combineReducers({
    collectionTitle: collectionTitleReducer,
    duration: durationReducer,
    id: idReducer,
    poster: posterReducer,
    contentURL: contentURLReducer,
    title: titleReducer,
    titleId: titleIdReducer,
    vttURL: vttURLReducer,
    type: typeReducer,
    mimeType: mimeTypeReducer

});


// WEBPACK FOOTER //
// ./src/player/videoSource/reducer.js